import { uiText } from '../i18n/uiText';
export const SMART_VIEWS = {
  all: {
    key: 'all',
    label: uiText("Все аудиты"),
    description: uiText("Полный реестр без сценарных ограничений и скрытых фильтров."),
  },
  attention_needed: {
    key: 'attention_needed',
    label: uiText("Требуют действий"),
    description: uiText("Аудиты с незаполненными обязательными полями, фото или открытыми замечаниями."),
  },
  my_active: {
    key: 'my_active',
    label: uiText("Мои активные"),
    description: uiText("Аудиты, где я назначен аудитором и работа ещё не завершена."),
  },
  upcoming: {
    key: 'upcoming',
    label: uiText("Предстоящие 7 дней"),
    description: uiText("Запланированные в ближайшую неделю проверки."),
  },
  completed_recent: {
    key: 'completed_recent',
    label: uiText("Недавно завершённые"),
    description: uiText("Аудиты, завершённые за последние 7 дней."),
  },
};

function hasAttention(audit) {
  const validation = audit?.validation || {};
  return ((validation.missing_required || []).length > 0)
    || ((validation.missing_required_photos || []).length > 0)
    || Number(validation.open_issues_count || 0) > 0;
}

function withinDays(value, days) {
  if (!value) return false;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return false;
  const diff = (date.getTime() - Date.now()) / 86400000;
  return diff >= 0 && diff <= days;
}

function withinLastDays(value, days) {
  if (!value) return false;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return false;
  const diff = (Date.now() - date.getTime()) / 86400000;
  return diff >= 0 && diff <= days;
}

export function matchSmartView(audit, viewKey, user) {
  if (!viewKey || viewKey === 'all') return true;
  if (viewKey === 'attention_needed') return hasAttention(audit);
  if (viewKey === 'my_active') {
    return ['in_progress', 'not_started', 'ready'].includes(audit?.status)
      && String(audit?.auditor?.id || '') === String(user?.id || '');
  }
  if (viewKey === 'upcoming') return withinDays(audit?.scheduled_date, 7);
  if (viewKey === 'completed_recent') {
    return ['completed', 'closed'].includes(audit?.status)
      && withinLastDays(audit?.completed_date || audit?.updated_at, 7);
  }
  return true;
}

export function getAttentionSignals(audit) {
  const validation = audit?.validation || {};
  const chips = [];
  if ((validation.missing_required || []).length > 0) chips.push(uiText("{v0} незаполн.", {v0: (validation.missing_required.length)}));
  if ((validation.missing_required_photos || []).length > 0) chips.push(uiText("{v0} без фото", {v0: (validation.missing_required_photos.length)}));
  if (Number(validation.open_issues_count || 0) > 0) chips.push(uiText("{v0} замеч.", {v0: (validation.open_issues_count)}));
  return chips;
}
